import axios from "axios";
import { getCleanAccessToken } from "@/utils/auth-token";

const prefix = import.meta.env.VITE_BE_HOST || "http://localhost:8080";

const getConfig = () => {
  return {
    headers: {
      "x-access-token": getCleanAccessToken(),
    },
  };
};

export const apiPostBulkSms = async (message, selectedCustomers, purpose) => {
  return axios.post(
    prefix + `/customer/bulk_sms`,
    { message, selectedCustomers, channel: "sms", purpose },
    getConfig(),
  );
};
